var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivateYourProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 46",
    width: 53,
    height: 46,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "how it works") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 53,
    height: 46,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAuCAMAAAC/KaEaAAAAAXNSR0IB2cksfwAAASlQTFRFZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RZi2RL9lx7QAAAGN0Uk5TAGvp/+WfKlL6Za5PwOIFRnaAyAPuCdiVmLca/f7j4N5sOVBLBDf3vAYR5oGP3Ps/71ZjDY2n9ik9eRbUwvxXfflv8app8kKFAUPN7TPfi8409PDrMSTFuHAskMFyotHo+IMIw9pVPAAAAUJJREFUeJzN1ddSg0AUgOETT5SIYItRYwhqYmIs2HvsNWrsvZf3fwhhJBucsHA4V/53sPPt7OzsAoB/sSaMN7dIBmUp6JRojaZU/K0tktJcpbdzFHawVCdLdf1X1c1RyR6OUpChUr1C9dFVv0Cop6gohp7SAzSkZLwKjazpbVAbss/mcE6UH3FQoYghjZbAO3HeRmPjYQhxArxPOVtNhiM0G5RFUNigTAKaYimNozLTDDUzC5GVMTcP0RUuAEdZLBVnqUWOWlpmKHMFGGoVOKq4Vlfl9Q2iwk2htuwrvU1UOzW169z8PaLar6kD59emEtWhWOFRBY4TNGUl67thnRhIUqdV/50/C1Tn4K/SgepCoi6vgpTpqvK16ObWeXGnBqh7+Ye+8CBVj3IF8PSs+6KXUpACqFRf394/Pv+Y7Ne3O/oDUUoxk+RwTXIAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "how it works"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Vector Smart Object",
    href: "#img1",
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateYourProduct);
export default __webpack_public_path__ + "static/media/activate-your-product.b7e47b607b8ae31b45fee9717f3ec6be.svg";
export { ForwardRef as ReactComponent };